"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ChatRightHeader;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const user_1 = require("../../store/selectors/user");
const document_1 = require("../../store/selectors/document");
const useDocument_1 = __importDefault(require("../../hooks/useDocument"));
const AppButton_1 = require("../AppButton");
const ChatThreadsHeaderButton_1 = __importDefault(require("./ChatThreadsHeaderButton"));
const ChatMenu_1 = __importDefault(require("./ChatMenu"));
function ChatRightHeader() {
    const { showShareLink } = (0, useDocument_1.default)();
    const charcter = (0, react_redux_1.useSelector)(user_1.selectCharacterProfile);
    const document = (0, react_redux_1.useSelector)(document_1.selectDocumentJson);
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.container, children: [(0, jsx_runtime_1.jsx)(ChatThreadsHeaderButton_1.default, { menuHorizontalOffset: 104 }), document && (0, jsx_runtime_1.jsx)(AppButton_1.ShareButton, { onPress: () => showShareLink(document) }), (0, jsx_runtime_1.jsx)(ChatMenu_1.default, { character: charcter })] }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        flexDirection: 'row',
        gap: 8,
        alignItems: 'center',
    },
});
